import { createSlice } from "@reduxjs/toolkit";
import {
  GetSingleServerType, // ✅ Fixed: Corrected from getSingleServer
  blockServerType,
  getAllServerType,
  saveNewServerType,
  updateServiceType, // ✅ Fixed: Corrected from updateServer
} from "../actions/servertype";

const initialState = {
  servers: [],
  singleServer: null,
  loading: false,
  error: null,
  totalCount:0,
};

const serverTypeSlice = createSlice({
  name: "server-type",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Get Single Server
      .addCase(GetSingleServerType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetSingleServerType.fulfilled, (state, action) => {
        state.loading = false;
        state.singleServer = action.payload;
      })
      .addCase(GetSingleServerType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Save New Server
      .addCase(saveNewServerType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveNewServerType.fulfilled, (state, action) => {
        state.loading = false;
        state.servers.push(action.payload);
      })
      .addCase(saveNewServerType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Get All Servers
      .addCase(getAllServerType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllServerType.fulfilled, (state, action) => {
        const { result, totalDocument } = action.payload;

        state.servers = result;
        state.totalCount = totalDocument;

        state.loading = false;
      })
      .addCase(getAllServerType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Update Server (Renamed correctly to updateService)
      .addCase(updateServiceType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateServiceType.fulfilled, (state, action) => {
        state.loading = false;
        state.servers = state.servers.map((server) =>
          server.id === action.payload.id ? action.payload : server
        );
      })
      .addCase(updateServiceType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Block Server
      .addCase(blockServerType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(blockServerType.fulfilled, (state, action) => {
        state.loading = false;
        state.servers = state.servers.filter(
          (server) => server.id !== action.payload.id
        );
      })
      .addCase(blockServerType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default serverTypeSlice.reducer;
